import { useState, useEffect } from 'react';

/**
 * Detects if the device is a mobile/touch device
 * Checks for touch capability rather than just screen width
 * This ensures mobile UI stays active in landscape mode
 */
export const isMobileDevice = () => {
  // Check for touch capability
  const hasTouch = 
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches;
  
  // Check for mobile-like viewport (width <= 1024px to catch landscape tablets)
  // OR if it's a touch device regardless of width
  const isSmallViewport = window.innerWidth <= 1024;
  
  // Mobile if: touch device AND (small viewport OR explicitly touch-only)
  // This keeps mobile UI on in landscape mode for touch devices
  return hasTouch && (isSmallViewport || window.matchMedia('(hover: none)').matches);
};

/**
 * Hook-friendly version that updates on resize
 * Returns current mobile state
 */
export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(() => isMobileDevice());
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    
    // Also listen for orientation changes
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);
  
  return isMobile;
};

